/**
 * @generated SignedSource<<2d9c6d6f92ffa68d22ca34f1616ae2c1>>
 * @relayHash 3b56cf2c02a3d609bd032afc04aa717c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8427e6324f4143c7ea10d2f41f01c03e756aa65f6f0da9ddcddd47114798cf67

import type { ConcreteRequest } from 'relay-runtime';
export type ContainerType = "BLOGPOST" | "DATABASE" | "PAGE" | "SPACE" | "WHITEBOARD" | "%future added value";
export type GraphQLReactionContentType = "BLOGPOST" | "COMMENT" | "PAGE" | "%future added value";
export type ConfluenceReactedUsersInput = {
  containerId?: string | null;
  containerType?: ContainerType | null;
  contentId: string;
  contentType: GraphQLReactionContentType;
  emojiId: string;
};
export type InlineReactionsPubSubHandlerActorQuery$variables = {
  cloudId: string;
  input: ConfluenceReactedUsersInput;
};
export type InlineReactionsPubSubHandlerActorQuery$data = {
  readonly confluence_reactedUsers: {
    readonly confluencePerson: ReadonlyArray<{
      readonly accountId: string | null;
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
    } | null>;
  } | null;
};
export type InlineReactionsPubSubHandlerActorQuery = {
  response: InlineReactionsPubSubHandlerActorQuery$data;
  variables: InlineReactionsPubSubHandlerActorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceReactedUsersResponsePayload",
    "kind": "LinkedField",
    "name": "confluence_reactedUsers",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluencePerson",
        "kind": "LinkedField",
        "name": "confluencePerson",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "accountId"
          },
          {
            "kind": "ScalarField",
            "name": "displayName"
          },
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "profilePicture",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "path"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "InlineReactionsPubSubHandlerActorQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InlineReactionsPubSubHandlerActorQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3b56cf2c02a3d609bd032afc04aa717c",
    "id": "8427e6324f4143c7ea10d2f41f01c03e756aa65f6f0da9ddcddd47114798cf67",
    "metadata": {},
    "name": "InlineReactionsPubSubHandlerActorQuery",
    "operationKind": "query",
    "text": "query InlineReactionsPubSubHandlerActorQuery($cloudId:ID!,$input:ConfluenceReactedUsersInput!){confluence_reactedUsers(cloudId:$cloudId,input:$input){confluencePerson{accountId,displayName,profilePicture{path}}}}"
  }
};
})();

(node as any).hash = "a1e84416e2dd1c9ba82fe43078a7880b";

export default node;
